'use client';

import { c as _c } from "react/compiler-runtime";
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { P3 } from '@algoacademy/design-system/web/typography/Paragraph';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { cn } from '@/app/_lib/utils';
import type { JobOfferInTheListDTO } from '../../page';
import { JobOfferList } from './JobOfferList';
export function JobOfferListAndContent(t0) {
  const $ = _c(17);
  const {
    jobOfferList,
    children,
    canManageJobOffers
  } = t0;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("oferta");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const jobOfferId = t1;
  const isMobile = useMediaQuery("(max-width: 1023px)");
  const isReadingJobOfferWhileInMobileView = isMobile && jobOfferId;
  const t2 = isReadingJobOfferWhileInMobileView ? "hidden lg:block" : "block";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("w-full lg:max-w-96", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LightCard className="flex-1 space-y-4 px-6"><div className="flex min-h-[20vh] items-center justify-center"><div>Ładowanie listy ofert pracy...</div></div></LightCard>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== canManageJobOffers || $[6] !== jobOfferList) {
    t5 = <Suspense fallback={t4}><JobOfferList jobOfferList={jobOfferList} canManageJobOffers={canManageJobOffers} /></Suspense>;
    $[5] = canManageJobOffers;
    $[6] = jobOfferList;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <section className={t3}>{t5}</section>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== isReadingJobOfferWhileInMobileView) {
    t7 = isReadingJobOfferWhileInMobileView ? <section className="flex-1 lg:hidden"><div className="flex items-center"><Link className="flex flex-row items-center gap-x-2" href="/kariera"><ArrowLeftIcon className="h-4 w-4 text-algoprimary" /><P3 className="font-semibold text-algoprimary">Powrót do ofert pracy</P3></Link></div><VerticalSpacer size="content" />{children}</section> : null;
    $[11] = children;
    $[12] = isReadingJobOfferWhileInMobileView;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <section className="mx-auto flex flex-row gap-x-4 xl:gap-x-6">{t6}{t7}</section>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}